import Nullstack from 'nullstack';
export default function IconVectorOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-vector-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6.68 6.733a0.996 .996 0 0 1 -.68 .267h-2a1 1 0 0 1 -1 -1v-2c0 -.276 .112 -.527 .293 -.708"
  }), "   ", Nullstack.element("rect", {
    x: "17",
    y: "3",
    width: "4",
    height: "4",
    rx: "1"
  }), "   ", Nullstack.element("path", {
    d: "M20.72 20.693a0.997 .997 0 0 1 -.72 .307h-2a1 1 0 0 1 -1 -1v-2c0 -.282 .116 -.536 .304 -.718"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "17",
    width: "4",
    height: "4",
    rx: "1"
  }), "   ", Nullstack.element("path", {
    d: "M5 7v10"
  }), "   ", Nullstack.element("path", {
    d: "M19 7v8"
  }), "   ", Nullstack.element("path", {
    d: "M9 5h8"
  }), "   ", Nullstack.element("path", {
    d: "M7 19h10"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}